import styled from "styled-components";
import { Backdrop, CircularProgress } from "@mui/material";
import { useState } from "react";

const Container = styled.div`

`;

/**
 * 
 * @param {Object} props
 * @param {boolean} props.open
 * @param {function} props.onClose
 * @returns 
 */
function BackdropHookComponent({ open, onClose }) {
    return (
        <Container>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 9999 }}
                open={open}
                onClick={typeof (onClose) === 'function' ? () => onClose() : () => { ; }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Container>
    );
}

const useBackdropHook = () => {
    const [open, setOpen] = useState(false);

    const onActionOpen = () => {
        setOpen(true);
    }

    const onActionClose = () => {
        setOpen(false);
    }

    return {
        open: open,
        onActionOpen: onActionOpen,
        onActionClose: onActionClose
    }
}
export { useBackdropHook, BackdropHookComponent };